// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import firebase from "firebase";
import { ref, onUnmounted } from "vue";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBCPY53ZVGj9oDQUH3pEXaEmiOQ0pZEBeM",
  authDomain: "am-distributor-locator.firebaseapp.com",
  projectId: "am-distributor-locator",
  storageBucket: "am-distributor-locator.appspot.com",
  messagingSenderId: "118565748043",
  appId: "1:118565748043:web:b9984a74a8b01a95f23cce",
  measurementId: "G-X72B1YW61H",
};

// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const distributorsCollection = db.collection("distributors");
// const analytics = getAnalytics(app);

// Create new distributor & store it in DB
export const createDistributor = (distributor) => {
  return distributorsCollection.add(distributor);
};

// Get specific distributor from DB
export const getDistributor = async (id) => {
  const distributor = await distributorsCollection.doc(id).get();
  return distributor.exists ? distributor.data() : null;
};

// Update specific distributor in DB
export const updateDistributor = (id, distributor) => {
  return distributorsCollection.doc(id).update(distributor);
};

// Delete distributor from DB
export const deleteDistributor = (id) => {
  return distributorsCollection.doc(id).delete();
};

// Hook listener
export const useLoadDistributors = () => {
  const distributors = ref([]);

  const close = distributorsCollection.onSnapshot((snapshot) => {
    distributors.value = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  });

  onUnmounted(close);

  return distributors;
};
